import 'styles/equipmentHouseLeeds.scss'
import {Urls} from '../constants'
import "../base/base.js";

(function () {
    /* global $ */
    "use strict";

    // Contrast
    function checkContrastFile () {
        if($('.js-contrast-style').first().prop('disabled') !== true){
            $('body').addClass('contrast')
        } else {
            $('body').removeClass('contrast')
        }
    }

    function pageResultsActions(checkContrastFile) {
     
        var checkExistApp = setInterval(function () {

            if ($('table').length > 0) {
                clearInterval(checkExistApp);
                checkContrastFile();
            };
           
        }, 200); // check every 200ms
    }


    var Attributes = {
        init: function () {
            this.adjustDom();
            this.bindUIActions();
            this.unload();
        },

        adjustDom: function () {
            // Check contrast call
            $(document).ready ( function () {
                setTimeout(() => {
                    checkContrastFile();
                }, 1000);                   
            });

        },

        bindUIActions: function () {
            
        $('body').on('click', '.js-switch-css-contrast', function () {
            setTimeout(() => {
                checkContrastFile() 
              }, 100);
        })

        $('body').on('click', '.js-switch-css-normal', function () {
            setTimeout(() => {
                checkContrastFile() 
              }, 100);
        })

        $('body').on('click', '.page-1 .form-checkbox__option label', function () {
            setTimeout(() => {
                checkContrastFile() 
              }, 100);
        })


        $('body').on('click', '.edit-categories', function () {
            setTimeout(() => {
                checkContrastFile() 
              }, 100);
        })


        $('body').on('click', '.page-2 .js-tab-buttons ', function () {
            setTimeout(() => {
                checkContrastFile() 
              }, 100);
        })

        $('body').on('click', '.page-2 .question-type-radio label ', function () {
            setTimeout(() => {
                checkContrastFile() 
              }, 100);
        })      

        $('body').on('click', '.page-2 .form-checkbox__option label', function() {

            function handleTargetElementClick(event) {            
                checkContrastFile();
            }
          
            setTimeout(() => {
                checkContrastFile();
            }, 100);

            var checkExistApp = setInterval(function () {
                if ($('.js-section-finished-btn').length > 0) {
                    clearInterval(checkExistApp);
                    var targetElement = document.querySelector('.js-section-finished-btn')
                    targetElement.addEventListener('click', handleTargetElementClick);
                }
            }, 200)        
        
        });        

        $('body').on('click', '.page-2 .js-finish-preview', function () {
            setTimeout(() => {
                checkContrastFile() 
              }, 100);
        })

        $('body').on('click', '.js-see-dumy-results', function () {
            setTimeout(() => {
                checkContrastFile() 
              }, 100);
        })

        $('body').on('change', '.page-assessment-results .form-radio__option input', function () {
            setTimeout(() => {
                checkContrastFile() 
              }, 100);
        })

        $('body').on('change', '.page-assessment-results .form-checkbox__option input', function () {
            setTimeout(() => {
                checkContrastFile() 
              }, 100);
        })

        $('body').on('click', '#app', function () {
                setTimeout(() => {
                    checkContrastFile() 
                }, 100);
        }) 
        
        $('body').on('click', '.answer-btns button', function(){
            if ( $(this).text().match('Finish') ) {
                pageResultsActions(checkContrastFile);
            }
        })
           

        },

        unload: function () {},
    };

    Attributes.init();
})();